export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_02.24997ef0.mp4";